module.exports = __webpack_public_path__ + "img/motorcycle-door.bffbcac3.jpg";